import React from 'react';
import * as XLSX from 'xlsx';

const RootCauseAnalysis = () => {
  const inspectionData = JSON.parse(sessionStorage.getItem('inspectionData') || '{}');
  const rcaData = inspectionData.RootCauseAnalysis;

  if (!rcaData) {
    return <p className="text-gray-500">No Root Cause Analysis data available</p>;
  }

  // Function to download data as Excel
  const downloadExcel = () => {
    const workbook = XLSX.utils.book_new();
    const worksheetData = [];

    // Headers for the Excel sheet
    worksheetData.push([
      'Date',
      'Shift',
      'Inspector Name',
      'Inspector Evidence',
      'Vendor Evidence',
      'Problem Category',
      'Description',
      'Manufacturing Line',
      'Initiation Date',
      'Target Date',
      'Closing Date',
      'Delayed Days',
      'Root Cause',
      'Corrective Action',
      'Preventive Action',
      'Status',
    ]);

    // Populate data (one row per problem)
    rcaData.problems.forEach((problem) => {
      worksheetData.push([
        rcaData.date,
        rcaData.shift,
        rcaData.inspectorName,
        rcaData.inspectorEvidence || 'N/A',
        rcaData.vendorEvidence || 'N/A',
        problem.category,
        problem.description,
        problem.manufacturingLine,
        problem.initiationDate,
        problem.targetDate,
        problem.closingDate,
        problem.delayedDays,
        problem.rootCause,
        problem.correctiveAction,
        problem.preventiveAction,
        problem.status,
      ]);
    });

    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    XLSX.utils.book_append_sheet(workbook, worksheet, 'RootCauseAnalysis');
    XLSX.writeFile(workbook, 'RootCauseAnalysisData.xlsx');
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center mb-4">
        <h2 className="text-2xl font-semibold text-gray-800">Root Cause Analysis</h2>
        <button
          onClick={downloadExcel}
          className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 focus:outline-none"
        >
          Download Excel
        </button>
      </div>

      {/* Scalar Fields */}
      <div className="mt-4">
        <h3 className="text-xl font-semibold text-gray-800 mb-4">
          {rcaData.date} - {rcaData.shift}
        </h3>
        <div className="grid grid-cols-2 gap-4">
          <p><strong>Inspector Name:</strong> {rcaData.inspectorName || 'N/A'}</p>
          <p><strong>Inspector Evidence:</strong> {rcaData.inspectorEvidence || 'N/A'}</p>
          <p><strong>Vendor Evidence:</strong> {rcaData.vendorEvidence || 'N/A'}</p>
        </div>
      </div>

      {/* Problems Table */}
      <div className="mt-4">
        <h4 className="font-semibold text-gray-700 mb-2">Problems</h4>
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white border rounded-lg">
            <thead>
              <tr className="bg-gray-100">
                <th className="px-4 py-2 text-left text-gray-700">Category</th>
                <th className="px-4 py-2 text-left text-gray-700">Description</th>
                <th className="px-4 py-2 text-left text-gray-700">Manufacturing Line</th>
                <th className="px-4 py-2 text-left text-gray-700">Initiation Date</th>
                <th className="px-4 py-2 text-left text-gray-700">Target Date</th>
                <th className="px-4 py-2 text-left text-gray-700">Closing Date</th>
                <th className="px-4 py-2 text-left text-gray-700">Delayed Days</th>
                <th className="px-4 py-2 text-left text-gray-700">Root Cause</th>
                <th className="px-4 py-2 text-left text-gray-700">Corrective Action</th>
                <th className="px-4 py-2 text-left text-gray-700">Preventive Action</th>
                <th className="px-4 py-2 text-left text-gray-700">Status</th>
              </tr>
            </thead>
            <tbody>
              {rcaData.problems.map((problem, index) => (
                <tr key={index} className="border-t">
                  <td className="px-4 py-2 text-gray-600">{problem.category || 'N/A'}</td>
                  <td className="px-4 py-2 text-gray-600">{problem.description || 'N/A'}</td>
                  <td className="px-4 py-2 text-gray-600">{problem.manufacturingLine || 'N/A'}</td>
                  <td className="px-4 py-2 text-gray-600">{problem.initiationDate || 'N/A'}</td>
                  <td className="px-4 py-2 text-gray-600">{problem.targetDate || 'N/A'}</td>
                  <td className="px-4 py-2 text-gray-600">{problem.closingDate || 'N/A'}</td>
                  <td className="px-4 py-2 text-gray-600">{problem.delayedDays || 'N/A'}</td>
                  <td className="px-4 py-2 text-gray-600">{problem.rootCause || 'N/A'}</td>
                  <td className="px-4 py-2 text-gray-600">{problem.correctiveAction || 'N/A'}</td>
                  <td className="px-4 py-2 text-gray-600">{problem.preventiveAction || 'N/A'}</td>
                  <td className="px-4 py-2 text-gray-600">{problem.status || 'N/A'}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default RootCauseAnalysis;